import * as v from "valibot";
import { rpcContract } from "../rpc";

export const generateVerificationUrlRpcContract = rpcContract({
  name: "generate-verification-url",
  paramsSchema: v.object({
    email: v.string(),
    onboarding: v.optional(v.boolean()),
  }),
  resultSchema: v.object({
    url: v.string(),
  }),
});

export type GenerateVerificationUrlParams = v.InferOutput<(typeof generateVerificationUrlRpcContract)["paramsSchema"]>;
export type GenerateVerificationUrlResult = v.InferOutput<(typeof generateVerificationUrlRpcContract)["resultSchema"]>;
